/* eslint-disable react/prop-types */
import SubmitContext from 'context/submit/submitContext'
import PageContext from 'context/page/pageContext'
import React, { useContext, useEffect, useState } from 'react'
import Switch from 'react-switch'
import { Col, Row, FormGroup, Input, Alert } from 'reactstrap'
import { Controller, ErrorMessage, useFormContext } from 'react-hook-form'
import { useFormUtils } from 'views/shared/useFormUtils'
import { isNotNumericDecimal } from 'context/Utilities'
import { packagingInitialState } from './constants'
import PlantCheeseProduct from 'models/PlantCheeseProduct'

const PlantCheeseNutrition = () => {
  const submitContext = useContext(SubmitContext)
  const pageContext = useContext(PageContext)

  const { current, setCurrent, updating } = submitContext
  const { setScrollToTop } = pageContext

  const [packaging, setPackaging] = useState(packagingInitialState)

  const methods = useFormContext()
  const { setSwitch, onChange, asterisk } = useFormUtils()

  useEffect(() => {
    setScrollToTop(true)
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    if (
      current?.category === packagingInitialState.category &&
      current?.subCategory === packagingInitialState.subCategory
    ) {
      const {
        category,
        subCategory,
        Calcium,
        CalciumCertification,
        Protein,
        ProteinCertification,
      } = current

      setPackaging({
        category,
        subCategory,
        Calcium,
        CalciumCertification: CalciumCertification ?? false,
        Protein,
        ProteinCertification: ProteinCertification ?? false,
      })
    } else if (!updating) {
      setCurrent(PlantCheeseProduct)
    }
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [current])

  return (
    <Row>
      <Col xs={6}>
        <FormGroup>
          <p>
            <strong>Calcium (mg) per 8 ounces {asterisk}</strong>
          </p>
          <Controller
            as={Input}
            type="number"
            step="0.01"
            name="Calcium"
            placeholder="Min 250mg calcium per 8 ounces"
            control={methods.control}
            rules={{
              required: '⚠ Please enter Calcium (mg) per 8 ounces',
              maxLength: {
                value: 6,
                message: '⚠ Calcium (mg) per 8 ounces exceeds 6 characters',
              },
              min: {
                value: 250,
                message:
                  '⚠ Calcium (mg) per 8 ounces is below the required 250mg minimum',
              },
              pattern: {
                value: /^\d+(\.\d{1,2})?$/,
                message: '⚠ Maximum two decimal places allowed.',
              },
            }}
            onKeyDown={e => isNotNumericDecimal(e.key) && e.preventDefault()}
            onChange={([event]) => {
              onChange(event)
              return event
            }}
          />
          <ErrorMessage
            errors={methods.errors}
            name="Calcium"
            as={<Alert color="danger" className="mt-3" />}
          />
        </FormGroup>
        <FormGroup>
          <p>
            <strong>Protein (g) per 8 ounces {asterisk}</strong>
          </p>
          <Controller
            as={Input}
            type="number"
            step="0.01"
            name="Protein"
            placeholder="Min 6.5g protein per 8 ounces"
            control={methods.control}
            rules={{
              required: '⚠ Please enter Protein (g) per 8 ounces',
              maxLength: {
                value: 4,
                message: '⚠ Protein (g) per 8 ounces exceeds 4 characters',
              },
              min: {
                value: 6.5,
                message:
                  '⚠ Protein (g) per 8 ounces is below the required 6.5g minimum',
              },
              pattern: {
                value: /^\d+(\.\d{1,2})?$/,
                message: '⚠ Maximum two decimal places allowed.',
              },
            }}
            onKeyDown={e => isNotNumericDecimal(e.key) && e.preventDefault()}
            onChange={([event]) => {
              onChange(event)
              return event
            }}
          />
          <ErrorMessage
            errors={methods.errors}
            name="Protein"
            as={<Alert color="danger" className="mt-3" />}
          />
        </FormGroup>
      </Col>

      <Col xs={6}>
        <FormGroup>
          <p>
            <strong>
              I certify that this product contains at least 250mg calcium per 8
              ounces. {asterisk}
            </strong>
          </p>
          <Controller
            as={Switch}
            name="CalciumCertification"
            id="CalciumCertification"
            control={methods.control}
            defaultValue={packaging.CalciumCertification}
            onChange={([checked, event, id]) => {
              setSwitch(checked, event, id)
              return checked
            }}
            rules={{ validate: value => value === true }}
          />
          <ErrorMessage
            errors={methods.errors}
            name="CalciumCertification"
            message={
              '⚠ You must certify that this product contains no less than the required minimum 250mg total calcium per 8 ounces.'
            }
            as={<Alert color="danger" className="mt-3" />}
          />
        </FormGroup>
        <FormGroup>
          <p>
            <strong>
              I certify that this product contains at least 6.5g protein per 8
              ounces. {asterisk}
            </strong>
          </p>
          <Controller
            as={Switch}
            name="ProteinCertification"
            id="ProteinCertification"
            control={methods.control}
            defaultValue={packaging.ProteinCertification}
            onChange={([checked, event, id]) => {
              setSwitch(checked, event, id)
              return checked
            }}
            rules={{ validate: value => value === true }}
          />
          <ErrorMessage
            errors={methods.errors}
            name="ProteinCertification"
            message={
              '⚠ You must certify that this product contains no less than the required minimum 6.5g total protein per 8 ounces.'
            }
            as={<Alert color="danger" className="mt-3" />}
          />
        </FormGroup>
      </Col>
    </Row>
  )
}

export default PlantCheeseNutrition
